import './front.scss';

import { OfficeLocationsFront } from './OfficeLocationsFront.js';



document.querySelectorAll( '[data-block="office-locations"]' ).forEach( ( element ) => {

	new OfficeLocationsFront( element );

} );

